import MuxPlayer from "@mux/mux-player-react/lazy";
import { h } from "preact";

// Boolean types must be strings like "true" or "false" to be accepted by mux

export default function MuxReactSimple(props) {
  return h(MuxPlayer, {
    ...props,
    streamType: "on-demand",
    //muted: "false",
    //loop: "false",
    crossorigin: "true",
    playsinline: "true",
    //preload: "auto",
    accentColor: "#fa2121",
    style: {
      "--media-object-fit": "cover",
      inset: 0,
    },
  });
}
